import { Component, Inject} from '@angular/core';
import { Router } from '@angular/router'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MessageDialogComponent } from '../message-dialog/message-dialog.component'
import { SpinnerDialogComponent } from '../spinner-dialog/spinner-dialog.component'
import { SharedService } from '../../services/shared.service'
import { HttpService } from '../../services/http.service'
import { Cancellation } from '../../models/cancellation'
import { Contract } from '../../models/contract'

@Component({
	selector: 'app-cancellation-dialog',
	templateUrl: './cancellation-dialog.component.html',
	styleUrls: ['./cancellation-dialog.component.css']
})
export class CancellationDialogComponent {
	cancellation: Cancellation
	contract: Contract
	spinner: MatDialogRef<SpinnerDialogComponent>
	
	constructor(
		private router: Router,
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<CancellationDialogComponent>,
		private shared: SharedService,
		private http: HttpService,
		@Inject(MAT_DIALOG_DATA) private data: any
	) { 
		let today = (new Date()).toISOString().split('T')[0]
		this.contract = data.contract
		this.cancellation = {
			"cancelReason": "Cancel from Sales Channel",
			"contractNo": this.contract.contractNo,
			"email": this.contract.email,
			"firstName": this.contract.firstName,
			"lastName": this.contract.lastName
		}
		console.log(this.contract)
	}

	onConfirm(): void {
		console.log(this.cancellation)
		this.spinner = this.dialog.open(SpinnerDialogComponent, {
			panelClass: 'transparent',
			disableClose: true
		})
		this.http.setCancellation(this.cancellation)
			.subscribe((response) => {
				if (response.success) { 
					this.spinner.close()
					this.dialog.open(
						MessageDialogComponent, { 
							data: { 
								title: 'Cancellation Complete', 
								description: 'Thank you for using Samsung Care+', 
								button: 'Go to home' 
							}
						})
						.afterClosed().subscribe(response => {
							this.onCancel()
							this.router.navigateByUrl('/start') 
						})
				} else {
					console.log(response)
					this.spinner.close()
					this.dialog.open(
						MessageDialogComponent, { 
							data: { 
								title: 'Cancellation Incomplete', 
								description: response.message + ' For further support, please contact us on 1-866-371-9501.',
								button: 'Close' 
							}
						})
				}
			}, (error) => {
				this.spinner.close()
				this.dialog.open(
					MessageDialogComponent, {
					data: {
						title: '',
						description: error.message,
						button: 'Close'
					}
				})
			})
	}

	onCancel(): void {
		this.dialogRef.close()
	}
}
